import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const EighteenPlusIcon = observer('EighteenPlusIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='#061A32'
            className={className}
            onClick={onClick}
        >
            <path
                d='M8.32669 15.4058V9.97594H7.07146V8.58449H10.0588V15.4058H8.32669Z'
                fill='fill'
            />
            <path
                d='M16.5684 10.3457C16.5684 10.9393 16.2473 11.4647 15.7121 11.7567C16.4613 12.068 16.9284 12.72 16.9284 13.479C16.9284 14.705 15.8385 15.4835 14.1357 15.4835C12.4328 15.4835 11.343 14.7147 11.343 13.5082C11.343 12.7297 11.849 12.068 12.6372 11.7567C12.0631 11.4355 11.6933 10.8907 11.6933 10.2971C11.6933 9.20717 12.647 8.51637 14.126 8.51637C15.6245 8.51637 16.5684 9.2267 16.5684 10.3457ZM12.9777 13.3331C12.9777 13.9072 13.3865 14.2283 14.1357 14.2283C14.885 14.2283 15.3034 13.917 15.3034 13.3331C15.3034 12.7688 14.885 12.4475 14.1357 12.4475C13.3864 12.4475 12.9777 12.7687 12.9777 13.3331ZM13.1529 10.443C13.1529 10.9296 13.5032 11.202 14.1357 11.202C14.7682 11.202 15.1185 10.9296 15.1185 10.443C15.1185 9.93714 14.7682 9.6549 14.1357 9.6549C13.5032 9.6549 13.1529 9.93714 13.1529 10.443Z'
                fill='fill'
            />
            <path
                d='M19.8106 9.35453C20.0985 10.2044 20.2446 11.0934 20.2446 12C20.2446 16.5461 16.5461 20.2446 11.9999 20.2446C7.4538 20.2446 3.75519 16.5461 3.75519 12C3.75519 7.4538 7.45374 3.75538 11.9999 3.75538C12.9066 3.75538 13.7956 3.90133 14.6453 4.18942V2.35468C13.787 2.11938 12.9005 2 11.9999 2C6.48599 2 2 6.48599 2 12C2 17.514 6.48599 22 11.9999 22C17.5139 22 21.9998 17.514 21.9998 12C21.9998 11.0995 21.8805 10.2129 21.6452 9.35453H19.8106Z'
                fill='fill'
            />
            <path
                d='M19.3116 4.68263V2.76518H17.9328V4.68263H16.0268V6.06131H17.9328V7.9787H19.3116V6.06131H21.2289V4.68263H19.3116Z'
                fill='fill'
            />
        </SvgElement>
    );
});
